export default function getDefaultState () {
  return {
    loading: false,
    errors: {},
    showApiErrors: false,
    countryCodesLoading: false,
    countryCodes: false
  }
}
